export const CONTEXT_MENU_LIST_TEST_ID = "context-menu-list";
